<template>
  <div>
    <el-dialog
      title="Preview"
      :visible="preview"
      width="50%"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="setPreview(false)"
      custom-class = "preview-dialog"
    >
    <div v-html="previewText"></div>
      <slot></slot>
    </el-dialog>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

export default {
  props: ['previewText'],
  computed: {
    ...mapState('global', ['preview'])
  },

  methods: {
    ...mapMutations('global', ['setPreview'])
  }
}
</script>
